import { useEffect, type ReactNode } from 'react';
import { applyTheme } from '@/lib/theme';
import { useTheme } from '@/stores/theme';

/** Syncs stored theme preference to the document on mount and when it changes. */
export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useTheme((s) => s.theme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return children;
}
